import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import SlideApi from '../../../api/SlideApi';
import '../../../css/reacttab.css';
import Pagination from 'react-bootstrap-4-pagination';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../../css/apppublic.css';
import Authen from '../../../core/Authen';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { confirmAlert } from 'react-confirm-alert';
import Select from 'react-select';
import '../../../css/reactselect.css';
import { QuanLyTapTin } from '../../../shared/quanlytaptin/QuanLyTapTin';
import ThongBao from '../../../core/ThongBao';


export const Slide = () => {
    var apiUrl = process.env.REACT_APP_API_URL.replace('api', '');
    const [listSlide, setListSlide] = useState([]);
    const [filter, setFilter] = useState('');
    const [show, setShow] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isXem, setIsXem] = useState(false);
    const [slide, setSlide] = useState({});
    const [type, setType] = useState({});
    const [opt, setOpt] = useState({});
    const [roleAdd, setRoleAdd] = useState(false);
    const [roleEdit, setRoleEdit] = useState(false);
    const [roleDel, setRoleDel] = useState(false);
    var noImage = "/uploadfiles/website/no_image-100x100.jpg";
    const url = process.env.REACT_APP_API_URL.replace('api', '');
    const [srcImage, setSrcImage] = useState(noImage);
    const [showModalImage, setShowModalImage] = useState(false);

    const { handleSubmit, register, reset, errors } = useForm();

    const [nhanVien, setNhanVien] = useState({ value: '1', label: 'Trang chủ' });

    useEffect(() => {
        setNhanVien(Authen.getUser());
        setRoleAdd(Authen.checkQuyen('SLIDE_CREATE'));
        setRoleEdit(Authen.checkQuyen('SLIDE_UPDATE'));
        setRoleDel(Authen.checkQuyen('SLIDE_DELETE'));
    }, []);

    const options = [
        // { value: '1', label: 'Trang chủ' },
        { value: '2', label: 'Trang chủ' },
        // { value: '3', label: 'Banner' }
    ]

    const [paginationConfig, setPaginationConfig] = useState({
        totalPages: 1,
        currentPage: 1,
        showMax: 5,
        size: 'sm',
        threeDots: true,
        prevNext: true,
        onClick: function (page) {
            if (page != null) {
                pageIndex = page;
                loadSlide();
            }
        }
    });

    var pageIndex = 1, pageSize = 20;

    const loadSlide = async () => {
        try {
            const params = {
                keyword: filter,
                pageIndex: pageIndex,
                pageSize: pageSize
            }
            const res = await SlideApi.getSlide(params);
            res.Items.map((x) => {
                x.Checked = false
            });
            setListSlide(res.Items);
            console.log(Slide);
            paginationConfig.totalPages = Math.ceil(res.TotalRow == 0 ? 1 : res.TotalRow / pageSize);
            paginationConfig.currentPage = pageIndex;
            setPaginationConfig(paginationConfig);
            setIsEdit(false);
            setSlide({});
        }
        catch {
            console.log('loi roi');
        }

    }

    useEffect(() => {
        loadSlide();
    }, [])

    const setFilt = (e) => {
        setFilter(e.target.value);
    }

    const Timkiem = () => {
        loadSlide();
    }

    const handleClose = () => {
        setShow(false);
        setIsXem(false);
    }
    const handleShow = () => {
        setIsXem(false);
        // loadType();
        setOpt(options[0]);
        setShow(true);
        reset(reset({
            Id: 0,
            Name: '',
            DisplayOrder: 1,
            Status: true,
            Description: ''
        }, [reset]), [reset]);
        setSrcImage(noImage);
    }

    const handleShowEdit = (isXem) => {
              let index = listSlide.findIndex(x => x.Checked);
        if (index !== -1) {
            SlideApi.getDetail(listSlide[index].Id).then((response) => {
                    reset({
                    Id: response.Id,
                    Name: response.Name,
                    Description: response.Description,
                    Image: response.Image,
                    Url: response.Url,
                    DisplayOrder: response.DisplayOrder,
                    Status: response.Status,
                    Content: response.Content,
                    Createddate: response.Createddate,
                    Createdby: response.Createdby,
                    Updateddate: response.Updateddate,
                    Updatedby: response.Updatedby,
                    Metakeyword: response.Metakeyword,
                    Metadescription: response.Metadescription,
                    Delete: response.Delete,
                    Thumbnailimage: response.Thumbnailimage,
                    Type: response.Type
                }, [reset])
                setSrcImage(response.Image);
                setIsXem(isXem);
                let index = options.findIndex(x => x.value == response.Type);
                if (index >= 0) {
                    setOpt(options[index])
                }
                else {
                    setOpt(options[0]);
                }
                setShow(true);
            });
        }
    }

    const rowClick = (Id) => {
        listSlide.map((x) => {
            if (x.Id === Id) {
                x.Checked = !x.Checked;
                if (x.Checked) {
                    setIsEdit(true);
                    setSlide(x);
                }
                else {
                    setIsEdit(false);
                    setSlide({});
                }
            }
            else {
                x.Checked = false;
            }
        });
    }

    const dateNow = () => {
        let date = new Date().getDate();
        let month = new Date().getMonth() + 1;
        let year = new Date().getFullYear();
        return year + '-' + month + '-' + date;
    }

    const onSubmit = async (data) => {
        try {
            data.Delete = false;
            data.Metakeyword = '';
            data.Metadescription = '';
            data.Image = srcImage;
            data.Thumbnailimage = data.Image;
            data.Content = '';
            data.Type = opt.value;
            if (data.Id == "0") {
                data.Createdby = nhanVien.Id;
                data.Updatedby = '';
                data.Createddate = dateNow();
                data.Updateddate = dateNow();
                console.log(data);
                const res = await SlideApi.createSlide(data);
            }
            else {
                data.Createdby = Slide.Createdby;
                data.Createddate = Slide.Createddate;
                data.Updateddate = dateNow();
                data.Updatedby = nhanVien.Id;
                console.log(data);
                const res = await SlideApi.updateSlide(data);
            }
            setShow(false);
            setIsXem(false);
            setIsEdit(false);
            setSlide({});
            loadSlide();
        }
        catch (ex) {
            console.log(ex.message);
        }

    }

    const onFileSelected = (event) => {
        setSrcImage(event);
    }

    const showViewModalImage = () => {
        setShowModalImage(true);
    }
    const CloseViewModalImage = () => {
        setShowModalImage(false);
    }

    const onChangeSelect = (optionSelected) => {
        setOpt(optionSelected);
    }

    const alertDell = () => {
        ThongBao.printConfirmationDialog("Bạn có đồng ý xóa dữ liệu đã chọn hay không?", () => {
            let lstChecked = listSlide.filter(x => x.Checked);
            if (lstChecked.length > 0) {
                // let lstId = [];
                // lstChecked.forEach(element => {
                //     lstId.push(element.Id);
                // });
                SlideApi.DeleteSlide(lstChecked[0].Id).then(() => {
                    loadSlide();
                })
            }
        });
    }

    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2">
                <div className="row ml-2">
                    <div className="col-md-4">
                        <h6 className="m-0 font-weight-bold text-primary">Slide</h6>
                    </div>
                    <div className="col-md-4">
                        <div className="input-group">
                            <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={setFilt} />
                            <div className="input-group-append">
                                <button className="btn btn-info btn-sm" type="button" onClick={Timkiem} ><i className='fas fa-search'></i> Tìm kiếm</button>
                            </div>
                        </div>
                    </div>
                    <div className="fluid-container col-md-4 text-right">
                        {roleAdd == true ? <button type="button" className="btn btn-success btn-sm ml-1" onClick={() => handleShow()}><i className='fas fa-plus'></i> Thêm</button> : ''}
                        {roleEdit == true ? <button type="button" className="btn btn-info btn-sm ml-1" disabled={!isEdit} onClick={() => handleShowEdit(false)}><i className='far fa-edit'></i> Sửa</button> : ''}
                        {roleDel == true ? <button type="button" className="btn btn-danger btn-sm ml-1" disabled={!isEdit} onClick={alertDell} ><i className='fas fa-trash-alt'></i> Xóa</button> : ''}
                        <button type="button" className="btn btn-primary btn-sm ml-1 mr-2" disabled={!isEdit} onClick={() => handleShowEdit(true)}><i className='far fa-eye'></i> Xem</button>
                    </div>
                </div>
            </div>

            <div className="card-body">
                <div>
                    <table className="table table-bordered" width="100%">
                        <thead>
                            <tr className=" text-center NhanCBox">
                                <th ></th>
                                <th >Hình ảnh</th>
                                <th >Tên Slide</th>
                                <th >Thứ tự</th>
                                <th >Mô tả</th>
                                <th >Trạng thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listSlide.map((item, key) => {
                                    return (
                                        <tr onClick={() => rowClick(item.Id)} key={key}>
                                            <td className="text-center col-status">
                                                <input type="radio" checked={item.Checked} onChange={e => item.Checked = e.target.value}></input>
                                            </td>
                                            <td className="col-img"><img src={apiUrl + item.Image}></img></td>
                                            <td >{item.Name}</td>
                                            <td className="col-status">{item.DisplayOrder}</td>
                                            <td >{item.Description}</td>
                                            <td className="text-center col-status">{item.Status ? <span className="label label-success cls-status-label">Kích hoạt</span> : <span className="label label-danger cls-status-label">Khóa</span>}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <div className="col-md-12 text-right">
                        <Pagination {...paginationConfig} />
                    </div>
                </div>
            </div>
            <Modal dialogClassName="modalLH" show={show} onHide={handleClose} backdrop="static" keyboard={false} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Slide</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="container-fluid">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-group row" hidden={true}>
                                <div className="col-md-3 col-sm-6 col-xl-3 col-form-label">
                                    <label className="nhanTK">ID <code>*</code></label>
                                </div>
                                <div className="col-md-9 col-sm-6 col-xl-9">
                                    <input className="form-control" name="Id" type="Text" ref={register()}></input>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Tên slide <code>*</code>
                                </div>
                                <div className="col-md-10 col-sm-6 col-xl-10">
                                    <input className="form-control" name="Name" type="Text" ref={register({ required: "Tên slide không được trống" })}></input>
                                    <span className="eRor">{errors.name && errors.name.message}</span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Kiểu
                                </div>
                                <div className="col-md-9 col-sm-6 col-xl-10">
                                    {/* <Select options={options} name="Type" onChange={onChangeSelect}  value={opt==[{}]?options[0]:opt} components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}/> */}
                                    <Select
                                        className="select"
                                        name="Type"
                                        placeholder="Chọn loại..."
                                        // defaultValue={selectedOption}
                                        value={opt == [{}] ? options[0] : opt}
                                        onChange={onChangeSelect}
                                        options={options}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Thứ tự
                                </div>
                                <div className="col-md-10 col-sm-6 col-xl-10">
                                    <input className="form-control" name="DisplayOrder" type="number" ref={register()} ></input>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Mô tả
                                </div>
                                <div className="col-md-10 col-sm-6 col-xl-10">
                                    <textarea className="form-control" name="Description" type="Text" ref={register()} ></textarea>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Image
                                </div>
                                <div className="col-md-3 col-sm-6 col-xl-3">
                                    <div className="thumbnail">
                                        {/* <img name="Image" ref={register()}  onChange={e=> slide.Image = e.target.value} onClick={showViewModalImage}/> */}
                                        <img name="Image" ref={register()} src={apiUrl + srcImage} onClick={showViewModalImage} />
                                    </div>

                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-2 col-sm-6 col-xl-2 col-form-label nhanLH">
                                    Trạng thái
                                </div>
                                <div className="col-md-3 col-sm-6 col-xl-3 mt-2 NhanCBox">
                                    <input type="Checkbox" name="Status" ref={register()} onChange={e => slide.Status = e.target.checked}></input>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a href="#" type="button" className="btn btn-info btn-sm ml-1" onClick={handleSubmit(onSubmit)} hidden={isXem}><i className='fas fa-save'></i> Lưu</a>
                    <a href="#" type="button" className="btn btn-danger btn-sm ml-1" onClick={handleClose} disabled><i className="fas fa-sign-out-alt"></i> Hủy</a>
                </Modal.Footer>
            </Modal>
            <QuanLyTapTin viewModal={showModalImage} closeModal={CloseViewModalImage} onFileSelected={(e) => onFileSelected(e)}></QuanLyTapTin>
        </div>


    );
};
